export default "__VITE_PUBLIC_ASSET__0af7a13e__"